import CustodianCashBalancesPage from "../pages/management-reporting/CustodianCashBalancesPage";

const AdministrationCashBalancesRoutes = {
    path: 'cashbalances/*',
    roles: [],
    element: CustodianCashBalancesPage,

};

export default AdministrationCashBalancesRoutes;